import { NgModule } from '@angular/core';
import { DidsService, VerificationDataService } from './services';
import { PortabilityService } from './services/portability.service';

@NgModule({
  providers: [DidsService, VerificationDataService, PortabilityService]
})
export class DomainDidsModule {}